import type { EffectPayloads } from '../../effects/types';

import styles from './MessageArtifacts.module.css';

type QualityData = EffectPayloads['REPORT_QUALITY_ISSUES'];
type Issue = QualityData['issues'][number];

const SEV_CLASS: Record<Issue['severity'], string> = {
  high: styles.sevhigh,
  medium: styles.sevmedium,
  low: styles.sevlow,
};

/** AP-451: report quality check results, surfaced inline. */
export function QualityIssues({ data }: { data: QualityData }) {
  const issues = data.issues ?? [];

  if (data.ok && issues.length === 0) {
    return (
      <div className={styles.artifact}>
        <div className={styles.title}>Report quality check</div>
        <div className={styles.ok}>✓ No quality issues found.</div>
      </div>
    );
  }

  return (
    <div className={styles.artifact}>
      <div className={styles.title}>
        Report quality check{' '}
        <span className={styles.unit}>
          ({issues.length} issue{issues.length === 1 ? '' : 's'})
        </span>
      </div>
      <ul className={styles.issueList}>
        {issues.map((issue) => (
          <li
            key={`${issue.section}-${issue.severity}-${issue.message}`}
            className={styles.issue}
          >
            <span className={`${styles.sev} ${SEV_CLASS[issue.severity]}`}>
              {issue.severity}
            </span>
            <span>
              {issue.section && (
                <span className={styles.issueSection}>{issue.section}: </span>
              )}
              {issue.message}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
